import DrawerItemButton from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DrawerItem/DrawerItemButton/DrawerItemButton';
import DrawerMenu from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DrawerItem/DrawerMenu/DrawerMenu';
import useDrawerMenu from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DrawerItem/DrawerMenu/hooks/userDrawerMenu';
import { NavbarItem } from '@src/main/ui/components/layout/common/Navbar/common/hooks/useNavbarItems';
import { FC, MouseEventHandler } from 'react';

const DrawerItem: FC<NavbarItem> = ({ icon, text, onClick, isActive, mobileOnly, menuItems }) => {
  const { open, close, anchorEl, onButtonLeave, onButtonEnter, onMenuEnter } = useDrawerMenu();

  const onClickButton: MouseEventHandler<HTMLAnchorElement> = (event) => {
    onClick();
    open(event);
  };
  const onMouseEnterButton: MouseEventHandler<HTMLAnchorElement> = (event) => {
    onButtonEnter();
    open(event);
  };

  return (
    <div onMouseLeave={onButtonLeave}>
      {!mobileOnly ? (
        <>
          <DrawerItemButton
            icon={icon}
            text={text}
            onClick={onClickButton}
            onMouseEnter={onMouseEnterButton}
            isActive={isActive}
          />
          {menuItems && menuItems.length > 0 ? (
            <DrawerMenu
              anchorEl={anchorEl}
              close={close}
              onMenuEnter={onMenuEnter}
              menuItems={menuItems}
            />
          ) : undefined}
        </>
      ) : undefined}
    </div>
  );
};

export default DrawerItem;
